var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Forms_Text_Input_Default",
    "data-name": "Forms/Text Input/Default",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.954,
    height: 10.972,
    viewBox: "0 0 15.954 10.972",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_System_Caret_Down_16px",
    "data-name": "Icon/System/Caret Down/16px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill_1",
    "data-name": "Fill 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1-2",
    "data-name": "Fill 1",
    d: "M.6,0,0,.806l9.63,7.075L0,15.156l.6.8,10.171-7.68a.5.5,0,0,0-.005-.8Z",
    transform: "translate(15.954) rotate(90)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1-3",
    "data-name": "Fill 1",
    d: "M.6,0,0,.806l9.63,7.075L0,15.156l.6.8,10.171-7.68a.5.5,0,0,0-.005-.8Z",
    transform: "translate(15.954) rotate(90)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1-4",
    "data-name": "Fill 1",
    d: "M.6,0,0,.806l9.63,7.075L0,15.156l.6.8,10.171-7.68a.5.5,0,0,0-.005-.8Z",
    transform: "translate(15.954) rotate(90)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1-5",
    "data-name": "Fill 1",
    d: "M.6,0,0,.806l9.63,7.075L0,15.156l.6.8,10.171-7.68a.5.5,0,0,0-.005-.8Z",
    transform: "translate(15.954) rotate(90)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1-6",
    "data-name": "Fill 1",
    d: "M.6,0,0,.806l9.63,7.075L0,15.156l.6.8,10.171-7.68a.5.5,0,0,0-.005-.8Z",
    transform: "translate(15.954) rotate(90)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1-7",
    "data-name": "Fill 1",
    d: "M.6,0,0,.806l9.63,7.075L0,15.156l.6.8,10.171-7.68a.5.5,0,0,0-.005-.8Z",
    transform: "translate(15.954) rotate(90)",
    fill: "#1a1446"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.89d0b4e4e5ecc4faf9450a248934c17e.svg";
export { ForwardRef as ReactComponent };